module.exports = __webpack_public_path__ + "img/unstaked-new-parchment.35103f0e.webp";